import { createApp, ref } from 'vue';
import { createPinia } from 'pinia';
import { FocusTrap } from 'focus-trap-vue';
import LanguageSelector from './components/LanguageSelector.vue';
import ModalOverlay from './components/ModalOverlay.vue';
import TileMedia from './components/TileMedia.vue';
import AccordionItem from "./components/AccordionItem.vue";
import AccordionBlock from "./components/AccordionBlock.vue";
import HamburgerButton from './components/HamburgerButton.vue';
import SubNavigation from './components/SubNavigation.vue';
import FlyoutPanel from './components/FlyoutPanel.vue';
import useMobileMenu from './composables/useMobileMenu';
import {useSwipeTrap} from "./composables";

 createApp({
    components: {
        LanguageSelector,
        ModalOverlay,
        TileMedia,
        AccordionItem,
        AccordionBlock,
        HamburgerButton,
        SubNavigation,
        FocusTrap,
        FlyoutPanel
    },
   setup() {
     const focusTrap = ref(null);

     return {
       focusTrap,
        ...useMobileMenu(),
        ...useSwipeTrap(focusTrap)
      }
   }
})
.use(createPinia())
.mount('#app');
